import * as React from 'react';

export enum ResponsiveSize {
    Small,
    Medium,
    Large
}

interface ResponsiveProps extends React.Props<Responsive> {
    children?: (size: ResponsiveSize) => JSX.Element;
}

interface ResponsiveState {
    viewportWidth: number;
}

export default class Responsive extends React.Component<ResponsiveProps, ResponsiveState> {
    constructor() {
        super();
        this.state = {
            viewportWidth: this.getWidth()
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.detectWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.detectWidth);
    }

    render() {
        const smallLimit = 1000;
        const mediumLimit = 1300;
        let size: ResponsiveSize;

        if (this.state.viewportWidth < smallLimit) {
            size = ResponsiveSize.Small;
        } else if (this.state.viewportWidth < mediumLimit) {
            size = ResponsiveSize.Medium;
        } else {
            size = ResponsiveSize.Large;
        }
        return this.props.children(size);
    }

    private detectWidth = () => {
        const newWidth = this.getWidth();
        if (this.state.viewportWidth !== newWidth) {
            this.setState({
                viewportWidth: newWidth
            });
        }
    };

    private getWidth() {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/Responsive.tsx
 **/